import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
    SettingOption,
} from '@appblocks/codegeneration/types';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import * as tios from './tios';
import * as simulator from './simulator';
import * as zephyr from './zephyr';

export default class SerialDataSendNode extends BaseNode {
    constructor() {
        super();
        this.name = 'Serial Data Send';
        this.id = 'node_ser_data_send';
        this.icon = 'HiCommandLine';
        this.requirements = [['tios', 'zephyr']];
        this.linkedFeature = 'general';


        const settings: Setting[] = [
            {
                id: 'SERIAL_PORT',
                name: 'Serial Port',
                settingType: SettingType.OPTION,
                required: true,
                default: '',
                capabilityRequirement: 'serial',
            },
            {
                id: 'DATA',
                name: 'Data',
                settingType: SettingType.STRINGVARIABLE,
                required: true,
                default: '',
            },
        ];

        this.inputs = [
            {
                name: 'Send Data',
                portId: 'data_send',
                params: [

                ],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getSettingValue(settingId: string): string {
        if (settingId === 'DISPLAY_NAME') {
            const project: ProjectConfiguration = this.project;
            const SERIAL_PORT = project.getFeature(this.getSettingValue('SERIAL_PORT'));
            const DATA = this.getSettingValue('DATA');
            if (SERIAL_PORT) {
                return `Send to {{$${SERIAL_PORT.getID()}}} data ${DATA}`;
            }
        }
        return super.getSettingValue(settingId);
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'simulator':
                return simulator.getCodeBlocks(this);
            case 'tios':
                return tios.getCodeBlocks(this);
            case 'zephyr':
                return zephyr.getCodeBlocks(this);
            default:
                return [];
        }
    }

    getDetails(): string {
        return `
`;
    }
}
